// Who may approve / reject leave — the same rule as the server's
// isLeaveApproverUser (src/auth.js): Super Admin / executives, any Admin, an
// HR or Accounts Department Admin, and the Accounts team. Everyone else applies
// for their own leave only.
type LeaveUser = { role?: string | null; department?: string | null; username?: string | null } | null | undefined;

const EXECUTIVE_ROLES = ['superadmin', 'owner', 'ceo'];

export function isLeaveApprover(user: LeaveUser): boolean {
  if (!user) return false;
  const role = String(user.role || '');
  const department = String(user.department || '');
  if (EXECUTIVE_ROLES.includes(role) || role === 'admin') return true;
  if (role === 'department_admin' && (department === 'hr' || department === 'accounts')) return true;
  if (department === 'accounts' || user.username === 'account' || /abhij/i.test(String(user.username || ''))) return true;
  return false;
}
